import { Button } from 'components';
import styles from './FeedbackButton.module.scss'

const FEEDBACK_URL: string = "https://forms.office.com/r/5qXgjShGdW";
type Props = {
    
}
export default function FeedbackButton({}: Props) {
    
    const openFeedbackForm = () => {
        window.open(FEEDBACK_URL, '_blank');
    }

    return (
        <Button
            className={styles.button}
            style={{borderBottomRightRadius: 0, 
                borderTopRightRadius: 0, 
                borderBottomLeftRadius: "0.25rem", 
                borderTopLeftRadius: "0.25rem"}}
            fillMode="solid"
            themeColor={"primary"}
            onClick={() => openFeedbackForm()}
        >
           <span className={styles["button-label"]}>FEEDBACK</span> 
        </Button>
    )
}